import axios from "axios";

const BASE_URL = "https://api.postcodes.io" as const;

const postcodeIoClient = axios.create({
  baseURL: BASE_URL,
});

export type PostcodeResult = {
  postcode: string;
  latitude: number;
  longitude: number;
  country: string;
  region: string;
  admin_ward: string;
  admin_district: string;
  admin_county: string | null;
  parish: string;
};

type PostcodeResponse = {
  status: number;
  result: PostcodeResult;
};

/**
 * Get latitude and longitude from a UK postcode using postcodes.io (free, no API key required)
 */
const getCoordinates = async (
  postcode: string,
): Promise<{ latitude: number; longitude: number }> => {
  const formattedPostcode = postcode.replace(/\s/g, "");

  const { data } = await postcodeIoClient.get<PostcodeResponse>(
    `/postcodes/${formattedPostcode}`,
  );

  return {
    latitude: data.result.latitude,
    longitude: data.result.longitude,
  };
};

/**
 * Validate if a UK postcode exists using postcodes.io
 */
const validate = async (postcode: string): Promise<boolean> => {
  const formattedPostcode = postcode.replace(/\s/g, "");

  try {
    const { data } = await postcodeIoClient.get<{
      status: number;
      result: boolean;
    }>(`/postcodes/${formattedPostcode}/validate`);

    return data.result;
  } catch {
    return false;
  }
};

export const postcodeIo = {
  getCoordinates,
  validate,
};
